import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: `0 0 ${tokens.spacingVerticalS} 0`,
  },
  tabList: {
    gap: tokens.spacingHorizontalS,
    '& .fui-Tab': {
      transitionProperty: 'background-color, border-color, color',
      transitionDuration: tokens.durationFaster,
      transitionTimingFunction: tokens.curveEasyEase,
    },
    '& .fui-Tab:enabled:hover': {
      border: `solid ${tokens.strokeWidthThin} ${tokens.colorTransparentStroke}`,
    },
    '& .fui-Tab:enabled:active': {
      border: `solid ${tokens.strokeWidthThin} ${tokens.colorTransparentStroke}`,
    },
    '& .fui-Tab[aria-selected="true"]:enabled:hover': {
      border: `solid ${tokens.strokeWidthThin} ${tokens.colorCompoundBrandStroke}`,
    },
    '& .fui-Tab[aria-selected="true"]:enabled:active': {
      border: `solid ${tokens.strokeWidthThin} ${tokens.colorCompoundBrandStroke}`,
    },
  },
})

export { useStyles }
